import './components/finn-footer-theme-sync.js';

import { trackEvent } from '@finn-no/pulse-sdk';
import './components/vend-banner.js';
import './components/tcf-privacy-manager.js';


function addForBusinessLinkClickHandler() {
  if (typeof window !== 'undefined') {
    const linkElement = document
        ?.querySelector('finn-footer')
        ?.shadowRoot?.querySelector('#footer-item-for-companies');

    if (linkElement) {
      linkElement.addEventListener('click', () => {
        trackEvent({
          type: 'Click',
          intent: 'Open',
          name: 'Global navigation',
          object: {
              id: 'nmp_ev37',
              name: 'Admin for companies link',
              type: 'UIElement',
              elementType: 'Link',
          },
          vertical: {
              name: 'common_pages',
          },
        })
      })
    }
  }
}

addForBusinessLinkClickHandler()